<template>
  <div>
    <h3>{{ panelTitle }}</h3>
    <section>
      <div class="form-inline">
        <label>Start time:</label>
        <VueCtkDateTimePicker
          v-model="editStartTime"
          :right="true"
          :no-label="false"
          :no-value-to-custom-elem="true"
          format="YYYY-MM-DD HH:mm"
          formatted="llll"
        >
          <input :value="editStartTime" placeholder="Select Date" />
        </VueCtkDateTimePicker>
      </div>
      <div class="form-inline">
        <label>End time:</label>
        <div>
          <VueCtkDateTimePicker
            v-model="editEndTime"
            :no-label="false"
            :right="true"
            :no-value-to-custom-elem="true"
            format="YYYY-MM-DD HH:mm"
            formatted="llll"
          >
            <input :value="editEndTime" placeholder="Select Date" />
          </VueCtkDateTimePicker>
        </div>
      </div>
      <div class="form-inline">
        <label>Channel:</label>
        <div>
          <input type="text" placeholder="Channel" v-model="editChannel" />
        </div>
      </div>
      <div class="form-inline">
        <label>Company:</label>
        <div>
          <model-select
            :options="companyOptions"
            v-model="editCompany"
            placeholder="Company"
          ></model-select>
        </div>
      </div>
      <div class="form-inline">
        <label>Project:</label>
        <div>
          <model-select
            :options="projectOptions"
            v-model="editProject"
            placeholder="Project"
          ></model-select>
        </div>
      </div>
      <div class="form-inline">
        <label>Work Type:</label>
        <div>
          <model-select
            :options="workTypeOptions"
            v-model="editWorkType"
            placeholder="Work Type"
          ></model-select>
        </div>
      </div>
      <div class="form-inline">
        <label>Summary:</label>
        <div>
          <textarea rows="3" placeholder="Summary" v-model="editSummary" />
        </div>
      </div>
      <div class="form-inline">
        <spinnerButton
          class="submit primary"
          :loading="submitLoading"
          @click.native="buttonClick"
          >{{ buttonLabel }}</spinnerButton
        >
      </div>
    </section>
  </div>
</template>

<script>
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
import { ModelSelect } from "vue-search-select";
import "vue-search-select/dist/VueSearchSelect.css";
import { dateformat, date2timestamp } from "@/utils/utils";
import { db } from "@/vendor/firebase";
import moment from "moment";
import spinnerButton from "@/components/public/SpinnerButton";

export default {
  props: ["propsData", "companyOptions", "submitLoading", "projectOptions"],
  components: {
    VueCtkDateTimePicker,
    ModelSelect,
    spinnerButton,
  },
  data() {
    return {
      panelTitle: null,
      buttonLabel: null,
      editType: null,
      editId: null,
      editStartTime: null,
      editEndTime: null,
      editChannel: null,
      editCompany: null,
      editWorkType: null,
      editSummary: null,
      editProject: null,

      workTypeOptions: [
        { text: "remote", value: "remote" },
        { text: "onsite", value: "onsite" },
        { text: "timesheet", value: "timesheet" },
      ],
    };
  },
  watch: {
    propsData: function () {
      this.initData();
    },
  },
  created: function () {
    this.initData();
  },
  methods: {
    initData: function () {
      this.editType = this.propsData.id ? "edit" : "add";
      if (this.editType == "add") {
        this.panelTitle = "Add Checkin";
        this.buttonLabel = "Add Checkin";
        this.editStartTime = null;
        this.editEndTime = null;
      } else {
        this.panelTitle = "Edit Checkin";
        this.buttonLabel = "Edit Checkin";
        this.editStartTime = moment(
          this.propsData.checkin,
          "MM/DD/YYYY HH:mm A"
        ).format("YYYY-MM-DD HH:mm");
        this.editEndTime = moment(
          this.propsData.checkout,
          "MM/DD/YYYY HH:mm A"
        ).format("YYYY-MM-DD HH:mm");
      }
      this.editChannel = this.propsData.channel;
      this.editCompany = this.propsData.company;
      this.editWorkType = {
        text: this.propsData.workType,
        value: this.propsData.workType,
      };
      this.editSummary = this.propsData.summary;
      this.editId = this.propsData.id;
      this.editProject = this.propsData.projectId;
    },
    buttonClick: function () {
      const data = {
        check_in: date2timestamp(this.editStartTime, true),
        check_out: date2timestamp(this.editEndTime, true),
        channel_id: this.editChannel ? this.editChannel : null,
        company: this.editCompany ? this.editCompany : null,
        work_type: this.editWorkType.value ? this.editWorkType.value : null,
        summary: this.editSummary ? this.editSummary : null,
        project_id: this.editProject ? this.editProject : null,
      };
      this.$emit("buttonClick", data, this.editId);
    },
  },
};
</script>
